<template>
    <div class="resumo-card" :class="tipo">
      <div class="card-content">
        <div class="card-icon">
          <span class="icon">{{ icone }}</span>
        </div>
        <div class="card-info">
          <div class="card-titulo">{{ titulo }}</div>
          <div class="card-valor">{{ valor }}</div>
          <div v-if="subtexto" class="card-subtexto">{{ subtexto }}</div>
        </div>
      </div>
      
      <!-- Indicador de Mudança -->
      <div v-if="mudanca" class="card-mudanca" :class="mudanca.tipo">
        <span class="mudanca-icon">{{ mudanca.tipo === 'positiva' ? '↗️' : '↘️' }}</span>
        <span class="mudanca-texto">{{ mudanca.texto }}</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ResumoCard',
    
    props: {
      titulo: {
        type: String,
        required: true
      },
      valor: {
        type: [String, Number],
        required: true
      },
      icone: {
        type: String,
        required: true
      },
      tipo: {
        type: String,
        default: 'primary',
        validator: value => ['primary', 'success', 'warning', 'danger', 'info'].includes(value)
      },
      subtexto: {
        type: String,
        default: null
      },
      mudanca: {
        type: Object,
        default: null
        // Formato: { tipo: 'positiva|negativa', texto: '+5% hoje' }
      }
    }
  }
  </script>
  
  <style scoped>
  .resumo-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }
  
  .resumo-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0,0,0,0.15);
  }
  
  .resumo-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--card-color);
  }
  
  .resumo-card.primary { --card-color: #1976d2; }
  .resumo-card.success { --card-color: #4caf50; }
  .resumo-card.warning { --card-color: #ff9800; }
  .resumo-card.danger { --card-color: #f44336; }
  .resumo-card.info { --card-color: #2196f3; }
  
  .card-content {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
    border-radius: 12px;
    background: var(--card-color);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.1;
  }
  
  .icon {
    font-size: 24px;
  }
  
  .card-info {
    flex: 1;
  }
  
  .card-titulo {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
    font-weight: 500;
  }
  
  .card-valor {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    line-height: 1;
    margin-bottom: 5px;
  }
  
  .card-subtexto {
    font-size: 12px;
    color: #999;
  }
  
  .card-mudanca {
    margin-top: 10px;
    padding: 5px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 3px;
  }
  
  .card-mudanca.positiva {
    background: #e8f5e8;
    color: #2e7d32;
  }
  
  .card-mudanca.negativa {
    background: #ffebee;
    color: #d32f2f;
  }
  
  .mudanca-icon {
    font-size: 10px;
  }
  
  /* Responsividade */
  @media (max-width: 768px) {
    .resumo-card {
      padding: 15px;
    }
    
    .card-content {
      gap: 10px;
    }
    
    .card-icon {
      width: 40px;
      height: 40px;
    }
    
    .icon {
      font-size: 20px;
    }
    
    .card-valor {
      font-size: 24px;
    }
  }
  </style>